export class AccountFilter {
  public userId: string;
  public organizationId: string;
  public onlyActive: boolean;
  public pageIndex: number;
  public pageSize: number;

  constructor() {
    this.userId = null;
    this.organizationId = null;
    this.onlyActive = true;
    this.pageIndex = 0;
    this.pageSize = 10;
  }
}
